import {
  ProgramQuestionWithAnswer,
  useProgram,
} from 'shared/providers/ProgramProvider';

type GetProgramProfileAnswer = NonNullable<
  ReturnType<typeof useProgram>['getProgramProfileAnswer']
>;

// A question is "prefilled from program" when the report itself has no
// saved answer yet, but the shared program profile already has one. The
// user still needs to save that value into the report.
export const isPrefilledFromProgram = (
  q: ProgramQuestionWithAnswer,
  getProgramProfileAnswer?: GetProgramProfileAnswer | null,
): boolean => {
  if (q.answer) return false;
  if (!q.isProgramQuestion) return false;
  if (!getProgramProfileAnswer) return false;
  const pa = getProgramProfileAnswer(q.questionId);
  if (!pa) return false;
  const hasText = !!(pa.text && pa.text.trim());
  const hasDate = !!(pa.date1 || pa.date2);
  const hasEnum = pa.answerId != null || pa.enumResponse?.dbId != null;
  return hasText || hasDate || hasEnum;
};
